import { Component } from '@theme/component';
import { morphSection, sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * POSKI – Zuletzt angesehen.
 *
 * Liest die zuletzt angesehenen Produkt-IDs aus dem localStorage (Horizon speichert sie
 * über recently-viewed-products.js) und lädt die passenden Produktkarten über die
 * Section-Rendering-API nach. Ohne Verlauf blendet sich die Section komplett aus.
 */
class PoskiRecentlyViewed extends Component {
  /** ID des aktuell angezeigten Produkts – wird aus der Liste gefiltert. @type {string} */
  #excludeId = '';

  connectedCallback() {
    super.connectedCallback();

    // Beim Nachladen (Antwort der Section-Rendering-API) ist bereits alles gerendert.
    if (this.dataset.hydrated === 'true') return;

    this.#excludeId = this.dataset.productId ?? '';
    this.#load();
  }

  /**
   * Lädt die zuletzt angesehenen Produkte nach.
   */
  async #load() {
    const { sectionId } = this.dataset;
    if (!sectionId) return;

    const maxProducts = Number(this.dataset.maxProducts) || 8;
    const ids = RecentlyViewed.getProducts()
      .filter(/** @param {string} id */ (id) => String(id) !== String(this.#excludeId))
      .slice(0, maxProducts);

    if (ids.length === 0) {
      this.#hide();
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', ids.map(/** @param {string} id */ (id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(sectionId, false, url);

      if (!html?.trim()) {
        this.#hide();
        return;
      }

      await morphSection(sectionId, html, { mode: 'hydration', injectStylesheet: true });

      // Produkte können zwischenzeitlich gelöscht oder ausgeblendet worden sein.
      if (this.querySelector('.resource-list__item')) {
        this.hidden = false;
      } else {
        this.#hide();
      }
    } catch (error) {
      this.#hide();
      if (Shopify.designMode) console.error('POSKI Zuletzt angesehen:', error);
    }
  }

  /**
   * Blendet die Section aus – im Theme-Editor bleibt sie sichtbar, damit sie bearbeitbar ist.
   */
  #hide() {
    if (Shopify.designMode) return;
    this.hidden = true;
  }
}

if (!customElements.get('poski-recently-viewed')) {
  customElements.define('poski-recently-viewed', PoskiRecentlyViewed);
}
